import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';
import BillsPaymentTableRecords from '../BillsPaymentTableRecord';

const AllBillsPayment = () => (
  <div className="bills-payment-root-cover">
    <BillsPaymentTableRecords hasNameAndImage recordPermission="can-get-bills-payment" defaultUrl={AdminRouteName.billsPaymentRoute} toggleStorageId="all-bills-table-col" />
  </div>
);
export default AllBillsPayment;
